import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';
import styles from './AnunciosPage.module.css';

export default function AnunciosPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const { state } = useLocation();

  const [anuncios, setAnuncios]   = useState([]);
  const [selected, setSelected]   = useState(null);
  const [form, setForm]           = useState({ titulo: '', contenido: '', fijado: false });
  const [open, setOpen]           = useState(false);
  const [loading, setLoading]     = useState(true);

  const load = () => {
    api.get(`/asignaturas/${id}/anuncios`)
      .then(r => setAnuncios(r.data.data || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [id]);

  // Auto-abrir anuncio si viene desde AsignaturaPage
  useEffect(() => {
    if (state?.anuncioId && anuncios.length > 0) {
      const encontrado = anuncios.find(anuncio => anuncio.id === parseInt(state.anuncioId));
      if (encontrado) setSelected(encontrado);
    }
  }, [anuncios, state]);

  const submit = async e => {
    e.preventDefault();
    await api.post(`/asignaturas/${id}/anuncios`, form);
    setOpen(false);
    setForm({ titulo: '', contenido: '', fijado: false });
    load();
  };

  // Vista detalle
  if (selected) {
    return (
      <div className={styles.page}>
        <button className={styles.backBtn} onClick={() => setSelected(null)}>
          ← Volver a anuncios
        </button>
        <article className={styles.detail}>
          {selected.fijado == 1 && (
            <span className={styles.pinBadge}>📌 Anuncio fijado</span>
          )}
          <h1 className={styles.detailTitle}>{selected.titulo}</h1>
          <div className={styles.detailMeta}>
            <div className={styles.authorAvatar}>
              {selected.autor_nombre?.[0]}{selected.autor_apellidos?.[0]}
            </div>
            <div>
              <p className={styles.authorName}>
                {selected.autor_nombre} {selected.autor_apellidos}
              </p>
              <p className={styles.detailDate}>
                Publicado el {new Date(selected.created_at).toLocaleDateString('es-ES', {
                  weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
                })}
              </p>
            </div>
          </div>
          <div className={styles.detailDivider} />
          <div className={styles.detailBody}>
            {(selected.contenido || '').split('\n').map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>
        </article>
      </div>
    );
  }

  // Vista lista
  return (
    <div className={styles.page}>
      {user?.rol === 'profesor' && (
        <button className={styles.btnNew} onClick={() => setOpen(p => !p)}>
          {open ? 'Cancelar' : '+ Nuevo anuncio'}
        </button>
      )}

      {open && (
        <form onSubmit={submit} className={styles.form}>
          <input className={styles.input} placeholder="Título del anuncio"
            value={form.titulo}
            onChange={e => setForm(p => ({ ...p, titulo: e.target.value }))} required />
          <textarea className={styles.textarea} placeholder="Escribe el contenido..." rows="5"
            value={form.contenido}
            onChange={e => setForm(p => ({ ...p, contenido: e.target.value }))} required />
          <label className={styles.checkLabel}>
            <input type="checkbox" checked={form.fijado}
              onChange={e => setForm(p => ({ ...p, fijado: e.target.checked }))} />
            📌 Fijar este anuncio
          </label>
          <button type="submit" className={styles.btnSubmit}>Publicar anuncio</button>
        </form>
      )}

      {loading && <p className={styles.empty}>Cargando anuncios...</p>}

      {!loading && anuncios.length === 0 && (
        <div className={styles.emptyState}>
          <p className={styles.emptyIcon}>📢</p>
          <p className={styles.emptyText}>No hay anuncios publicados todavía.</p>
        </div>
      )}

      <div className={styles.list}>
        {anuncios.map(anuncio => (
          <div key={anuncio.id}
            className={`${styles.card} ${anuncio.fijado == 1 ? styles.fijado : ''}`}
            onClick={() => setSelected(anuncio)}>
            <div className={styles.cardLeft}>
              {anuncio.fijado == 1 && <span className={styles.pinIcon}>📌</span>}
              <div className={styles.cardAvatar}>
                {anuncio.autor_nombre?.[0]}{anuncio.autor_apellidos?.[0]}
              </div>
            </div>
            <div className={styles.cardBody}>
              <div className={styles.cardHeader}>
                <h4 className={styles.cardTitle}>{anuncio.titulo}</h4>
                <span className={styles.cardDate}>
                  {new Date(anuncio.created_at).toLocaleDateString('es-ES', {
                    day: '2-digit', month: 'short', year: 'numeric'
                  })}
                </span>
              </div>
              <p className={styles.cardAuthor}>{anuncio.autor_nombre} {anuncio.autor_apellidos}</p>
              <p className={styles.cardPreview}>{anuncio.contenido}</p>
            </div>
            <div className={styles.cardArrow}>›</div>
          </div>
        ))}
      </div>
    </div>
  );
}
